export enum Experiment {
  EnableMemberNameHtmlTagSettings = 'specs.profileCard.EnableHtmlTagSettings',
  HideMessageButtonForNonSocialChatUsers = 'specs.profileCard.HideMessageButtonForNonSocialChatUsers',
  EnableNewThumbnailSkins = 'enableNewThumbnailSkinsForMembersAreaPanels',
}
